var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    width: 36,
    height: 36,
    rx: 8,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 12.9028C19.1556 12.3492 19.8705 12 20.667 12C22.1398 12 23.3337 13.1939 23.3337 14.6667C23.3337 16.1394 22.1398 17.3333 20.667 17.3333C19.8705 17.3333 19.1556 16.9842 18.667 16.4305M20.667 24H12.667V23.3333C12.667 21.1242 14.4579 19.3333 16.667 19.3333C18.8761 19.3333 20.667 21.1242 20.667 23.3333V24ZM20.667 24H24.667V23.3333C24.667 21.1242 22.8761 19.3333 20.667 19.3333C19.9384 19.3333 19.2553 19.5281 18.667 19.8685M19.3337 14.6667C19.3337 16.1394 18.1398 17.3333 16.667 17.3333C15.1942 17.3333 14.0003 16.1394 14.0003 14.6667C14.0003 13.1939 15.1942 12 16.667 12C18.1398 12 19.3337 13.1939 19.3337 14.6667Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleEvent);
export default __webpack_public_path__ + "static/media/PeopleEvent.d3a5db32f8af4d89427d9417134ac8c3.svg";
export { ForwardRef as ReactComponent };